/**
 * Reusable mapping of the workspace job_category enum to its human-readable
 * labels. Stays in sync with `JobCategory` (backend/models.py).
 *
 * Usage:
 *   import { JOB_CATEGORY_OPTIONS, jobCategoryLabel } from '@/lib/jobCategory';
 *   <Select> {JOB_CATEGORY_OPTIONS.map(o => <SelectItem ...>{o.label}</SelectItem>)} </Select>
 *   <span>{jobCategoryLabel(value, language)}</span>
 *
 * Keep this file small and pure — no React, no API calls.
 */

export const JOB_CATEGORY_VALUES = ['pave_uni_amenagement', 'drain_fissure', 'crepis', 'other'];

const LABELS_FR = {
  pave_uni_amenagement: 'Pavé uni / aménagement paysager',
  drain_fissure: 'Drain français / fissure',
  crepis: 'Crépis',
  other: 'Autre',
};

const LABELS_EN = {
  pave_uni_amenagement: 'Interlocking pavers / landscaping',
  drain_fissure: 'French drain / foundation crack',
  crepis: 'Stucco',
  other: 'Other',
};

export function jobCategoryLabel(value, language = 'fr') {
  if (!value) return language === 'fr' ? 'Non spécifié' : 'Not set';
  const dict = language === 'fr' ? LABELS_FR : LABELS_EN;
  return dict[value] || value;
}

export function jobCategoryOptions(language = 'fr') {
  const dict = language === 'fr' ? LABELS_FR : LABELS_EN;
  return JOB_CATEGORY_VALUES.map((v) => ({ value: v, label: dict[v] }));
}
